import { ActivityFeedsPropData } from "../../../types/DispatchExplorer"

export const DefaultActivityFeed = ({
  data,
}: {
  data: ActivityFeedsPropData
}) => {
  return <b>{data ? String(data.value) : "empty"}</b>
}
